import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useMemo, useState } from "react";
import { LoyaltyApi } from "@jti/rest-api";
import { useSelector } from "@jti/store";
import { formatDate, LoyaltyPointsStatus as LoyaltyPointsStatusLib, useTranslations, } from "@jti/ui";
import { getTierDescription } from "./utils/getTierDescription";
export const LoyaltyPointsStatus = ({ pointsHistoryLabel, pointsHistoryUrl, secondaryCtaButtonLabel, secondaryCtaButtonUrl, tiers, ctaButtonLabel, ctaButtonUrl, isInEditor, }) => {
    const [tiersThresholds, setTiersThresholds] = useState([]);
    const isLogged = useSelector((state) => state.loyaltyCore.isLogged);
    const isRestricted = useSelector((state) => state.loyaltyCore.isRestricted);
    const { name: userTierName, current_tier_secured_till, points_to_maintain_current_tier, current_tier_assignment_date, cumulative_points, points_to_next_tier, next_tier_name, } = useSelector((state) => state.loyaltyCore.tier);
    const userTierToLowerCase = userTierName.toLowerCase();
    const { balance, expire_at, points_to_expire } = useSelector((state) => state.loyaltyCore.points);
    const { __ } = useTranslations();
    const currentTierThreshold = tiersThresholds.find((tier) => tier.name.toLowerCase() === userTierToLowerCase)?.condition_value || 0;
    const tiersInfo = useMemo(() => tiersThresholds.map(({ name, condition_value: min }, index, arr) => {
        const max = index < arr.length - 1 ? `${arr[index + 1]?.condition_value - 1}` : `${min}+`;
        const pointsRangeLabel = index < arr.length - 1 ? `${min} - ${max}` : max;
        const currentTierIndex = arr.findIndex((tier) => tier.name.toLowerCase() === userTierToLowerCase);
        const isAchieved = index <= currentTierIndex;
        return {
            tierName: __("loyalty.pointsStatus.tierStatusTierNameLabel", [name]),
            pointsRange: __("loyalty.pointsStatus.tierStatusPointsRangeLabel", [pointsRangeLabel]),
            isAchieved,
        };
    }), [tiersThresholds, __, userTierToLowerCase]);
    const isHidden = !isLogged || (isLogged && isRestricted);
    useEffect(() => {
        if (!isHidden) {
            LoyaltyApi.init()
                .getTiers()
                .then((response) => {
                setTiersThresholds(response.data);
            })
                .catch((error) => {
                console.error(error);
            });
        }
    }, [isHidden]);
    if (isHidden && !isInEditor) {
        return null;
    }
    const detailsBarRightDescription = points_to_expire ? (_jsxs(_Fragment, { children: [__("loyalty.pointsStatus.upperItemDetailsBarRightDescription", [points_to_expire]), " ", _jsx("b", { style: { fontWeight: "bold" }, children: formatDate(expire_at) })] })) : null;
    return (_jsx(LoyaltyPointsStatusLib, { upperItem: {
            title: __("loyalty.pointsStatus.upperItemTitle"),
            description: __("loyalty.pointsStatus.upperItemDescription"),
            displayBarLeftDescription: __("loyalty.pointsStatus.upperItemDisplayBarLeftDescription"),
            detailsBarRightDescription: detailsBarRightDescription,
            pointsLabel: __("loyalty.pointsStatus.upperItemPointsLabel"),
            pointsHistoryLabel,
            pointsHistoryUrl,
            detailsBarButtonLabel: ctaButtonLabel,
            detailsBarButtonUrl: ctaButtonUrl,
        }, bottomItem: {
            tierImage: tiers[userTierToLowerCase],
            title: __("loyalty.pointsStatus.bottomItemTitle", [userTierName]),
            description: __("loyalty.pointsStatus.bottomItemDescription"),
            displayBarLeftDescription: __("loyalty.pointsStatus.bottomItemDisplayBarLeftDescription"),
            detailsBarRightDescription: __("loyalty.pointsStatus.bottomItemDetailsBarRightDescription", [
                userTierName,
                formatDate(current_tier_assignment_date, "YYYY"),
            ]),
            detailsBarRightTitle: getTierDescription({
                isSecured: cumulative_points >= currentTierThreshold,
                currentTier: userTierName,
                pointsToNextTier: points_to_next_tier,
                nextTierName: next_tier_name,
                translateFunction: __,
                pointsToKeepTier: points_to_maintain_current_tier,
            }),
            detailsBarGeneralTitle: __("loyalty.pointsStatus.bottomItemDetailsBarGeneralTitle"),
            detailsBarButtonLabel: secondaryCtaButtonLabel,
            detailsBarButtonUrl: secondaryCtaButtonUrl,
        }, points: balance, cumulativePoints: cumulative_points, progressBarPointsForGoldTier: tiersThresholds[1]?.condition_value, progressBarPointsForBlackTier: tiersThresholds[2]?.condition_value, progressBarPointsTitle: __("loyalty.pointsStatus.progressBarPointsTitle", [new Date().getFullYear()]), progressBarPointsFooter: __("loyalty.pointsStatus.progressBarPointsFooter"), userTier: userTierName, date: formatDate(current_tier_secured_till), tiersInfo: tiersInfo }));
};
//# sourceMappingURL=LoyaltyPointsStatus.js.map